import { connect } from "react-redux";
import Dashboard from "./Dashboard";
import {
  changeGridFilters,
  getCaseList,
  getProfile,
  getNotifications,
  getStatistics,
  getGridFilters,
  getGridFilterMenus
} from "actions/homeowner/dashboard";
import { getSearchResults } from "actions/search";
import { resizeComplete } from "actions/layout";
import { saveClientSideFilters, clearClientSideFilters } from "actions/filters";
import { getQuickLists, getQuickListCount, getQuickListTemplates } from "actions/homeowner/quickList";

const mapStateToProps = state => {
  return {
    isFetchingCaseList: state.dashboard.fetchingCaseList,
    isFetchingSearchList: state.search.isFetching,
    isFetchingProfile: state.dashboard.fetchingProfile,
    isFetchingNotifications: state.dashboard.fetchingNotifications,
    isFetchingStatistics: state.dashboard.fetchingStatistics,
    isFetchingGridFilters: state.dashboard.fetchingGridFilters,
    isFetchingGridFilterMenus: state.dashboard.fetchingGridFilterMenus,
    gotInitialGridFilterMenus: state.dashboard.gotInitialGridFilterMenus,
    gotInitialGridFilters: state.dashboard.gotInitialGridFilters,

    caseListItems: state.dashboard.caseList,
    searchListItems: state.search.items,
    searchText: state.search.searchText,

    gridFilters: state.dashboard.gridFilters,
    gridFilterMenus: state.dashboard.gridFilterMenus,

    profile: state.dashboard.profile,
    userProfile: state.user.profile,
    notifications: state.dashboard.notifications,
    statistics: state.dashboard.statistics,
    token: state.user.profile.token,
    isAppraiser: state.user.profile.isAppraiser,
    isAppraiserManager: state.user.profile.isAppraiserManager,
    resizeRequired: state.layout.display.resizeRequired,

    clientSideFilters: state.filters.clientSideFilters,

    isFetchingQuickLists: state.quickList.isFetchingQuickLists,
    quickLists: state.quickList.quickLists,
    quickListTemplates: state.quickList.quickListTemplates,
  };
};

const mapDispatchToProps = dispatch => ({
  getDashboard() {
    dispatch(getProfile());
    dispatch(getNotifications());
    dispatch(getStatistics());
  },
  changeGridFilters(newGridFilters) {
    dispatch(changeGridFilters(newGridFilters));
  },
  refreshCaseList() {
    dispatch(getCaseList());
  },
  refreshSearchList(searchText) {
    dispatch(getSearchResults(searchText));
  },
  getGridFilters() {
    dispatch(getGridFilters("Valuation"));
  },
  getGridFilterMenus() {
    dispatch(getGridFilterMenus());
  },
  resizeComplete() {
    dispatch(resizeComplete());
  },
  saveClientSideFilters(filters) {
    dispatch(saveClientSideFilters(filters));
  },
  getQuickLists() {
    dispatch(getQuickLists());
    dispatch(getQuickListTemplates());
  },
  getQuickListCount(quickList) {
    dispatch(getQuickListCount(quickList));
  },
  clearClientSideFilters() {
    dispatch(clearClientSideFilters());
  }

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);
